import { useState, useEffect } from "react";
import { FaCheck } from "react-icons/fa";

const CookieConsent = ({ onAccept }) => {
	const [showBanner, setShowBanner] = useState(false);
	const [animate, setAnimate] = useState(false);

	useEffect(() => {
		const consent = localStorage.getItem("cookie_consent");
		if (consent === null) {
			setShowBanner(true);
			setTimeout(() => setAnimate(true), 200);
		}
	}, []);

	const handleAccept = () => {
		localStorage.setItem("cookie_consent", "true");
		setAnimate(false);
		setTimeout(() => setShowBanner(false), 300);
		if (onAccept) onAccept();
	};

	// const handleDecline = () => {
	// 	localStorage.setItem("cookie_consent", "false");
	// 	setAnimate(false);
	// 	setTimeout(() => setShowBanner(false), 300);
	// };

	if (!showBanner) return null;

	return (
		<div
			className={`fixed bottom-0 left-0 w-full bg-gray-500 text-white p-4 md:flex md:items-center md:justify-between z-50 shadow-lg transition-transform duration-300 ${
				animate ? "translate-y-0" : "translate-y-full"
			}`}
		>
			<p className="text-sm text-center md:text-left font-semibold">
				Questo sito utilizza cookie per migliorare l'esperienza utente, tutte le
				informazioni raccolte sono anonime.
			</p>
			<div className="mt-3 md:mt-0 flex justify-center gap-4">
				{/* <button
					onClick={handleDecline}
					className="bg-gray-700 hover:bg-gray-600 text-white font-medium px-4 py-1 rounded-md transition-all text-sm"
				>
					Rifiuta
				</button> */}
				<button
					onClick={handleAccept}
					className="bg-green-500 hover:bg-green-600 text-white font-bold px-6 py-1 rounded-lg transition-all text-lg shadow-md shadow-green-500/50 flex items-center gap-2"
				>
					<FaCheck /> Ho capito
				</button>
			</div>
		</div>
	);
};

export default CookieConsent;
